import type { DefaultPatientEventResponse } from "@/api";

import { HeartCoreCharts } from "@/features/patient/heartcore-charts/heartcore-charts";

/**
 * The charts shown in the worklist's Trends sheet — the same HeartCore report
 * the patient profile's HeartCore tab plots, events timeline included.
 *
 * `scopedScroll` points the charts' zoom bar at the sheet's own scroll area
 * instead of the page: it otherwise positions itself `fixed` against the
 * window, which inside a sheet means floating over content it doesn't belong to.
 */
export function TrendsCharts({
  patientId,
  events,
}: {
  patientId: number;
  events: DefaultPatientEventResponse[];
}) {
  return (
    <HeartCoreCharts
      patientId={patientId}
      variant="heartcore"
      events={events}
      scopedScroll
    />
  );
}
